/**
 * Утилита для скрытия splash screen
 * Может использоваться из разных слоев
 */
let canHide = false;

setTimeout(() => {
  canHide = true;
}, 4000);

export const hideSplashScreen = () => {
  const el = document.getElementById("splash-screen");

  if (!el) return;

  const waitTillCanHide = () => {
    if (canHide) {
      document.body.removeChild(el);
    } else {
      setTimeout(waitTillCanHide, 500);
    }
  };

  waitTillCanHide();
};

